import { createRouter, createWebHistory } from 'vue-router'
import { authGuard } from './guards/auth'
import { useAuthStore } from '@/stores/auth'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/projects'
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: { 
        requiresAuth: false,
        transition: 'fade'
      }
    },
    {
      path: '/auth/callback',
      name: 'auth-callback',
      component: () => import('@/views/AuthCallback.vue'),
      meta: { 
        requiresAuth: false,
        transition: 'fade'
      }
    },
    {
      path: '/projects',
      name: 'projects',
      component: () => import('@/views/ProjectList.vue'),
      beforeEnter: authGuard,
      meta: { 
        requiresAuth: true,
        transition: 'slide-left'
      }
    },
    {
      path: '/projects/:id',
      name: 'project-detail',
      component: () => import('@/views/ProjectDetail.vue'),
      beforeEnter: authGuard,
      meta: { 
        requiresAuth: true,
        transition: 'slide-left'
      }
    },
    {
      path: '/404',
      name: 'not-found',
      component: () => import('@/views/NotFound.vue'),
      meta: { 
        requiresAuth: false,
        transition: 'fade'
      }
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/404'
    }
  ]
})

// Global navigation guard to redirect authenticated users away from login
router.beforeEach((to, _from, next) => {
  const authStore = useAuthStore()
  
  // If user is authenticated and trying to access login page, redirect to projects
  if (to.name === 'login' && authStore.isAuthenticated && !authStore.isTokenExpired) {
    console.log('[Router] Authenticated user accessing login, redirecting to projects')
    next({ name: 'projects' })
    return
  }
  
  // Scroll to top on route change
  window.scrollTo(0, 0)
  next()
})

export default router
